import { api } from 'utility';
import { getRDandDetaileInvoiceUrl } from 'URLs';
class IssueInvoiceServices {
  async issueInvoice(data, businessId) {
    return api.post(getRDandDetaileInvoiceUrl(businessId), { preview: false, ...data });
  }

  async previewIssueInvoice(data, businessId) {
    return api.post(getRDandDetaileInvoiceUrl(businessId), { ...data, preview: true });
  }
}

export default new IssueInvoiceServices();
